import { render, staticRenderFns } from "./studentVideo.vue?vue&type=template&id=07fce93e&"
import script from "./studentVideo.vue?vue&type=script&lang=js&"
export * from "./studentVideo.vue?vue&type=script&lang=js&"
import style0 from "./studentVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "studentVideo.vue"
export default component.exports